var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3346 22.6667H10.668V21.3333C10.668 19.4924 12.1604 18 14.0013 18H18.0013C19.8422 18 21.3346 19.4924 21.3346 21.3333V22.6667ZM16.0013 16.6667C13.7922 16.6667 12.0013 14.8758 12.0013 12.6667C12.0013 10.4575 13.7922 8.66667 16.0013 8.66667C18.2104 8.66667 20.0013 10.4575 20.0013 12.6667C20.0013 14.8758 18.2104 16.6667 16.0013 16.6667Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.185748965177a37f2ca7d5f14562567a.svg";
export { ForwardRef as ReactComponent };